import axios from "axios";
import { baseUrl } from '../config/clientsConfig'
const LeadDbService = {
  fetchLeads: (
    userRole,
    selectedTeamId,
    bodTeamId,
    token,
    direction,
    searchKey
  ) => {
    let url = "";
    if (userRole === "Admin" || userRole === "CMO") {
      url = `${baseUrl}/leads`;
    } else if (userRole === "MD") {
      url = `${baseUrl}/leads?role=${userRole}&team=${selectedTeamId}`;
    } else if (userRole === "BOD") {
      url = `${baseUrl}/leads?role=${userRole}&team=${bodTeamId}`;
    }

    if (token && direction) {
      url += `?${direction}=${token}&direction=${direction}`;
    } else if (searchKey) {
      if (userRole === "MD") {
        url = `${baseUrl}/leads/search?role=${userRole}&team=${selectedTeamId}&searchKey=${searchKey}`;
      } else if (userRole === "BOD") {
        url = `${baseUrl}/leads/search?role=${userRole}&team=${bodTeamId}&searchKey=${searchKey}`;
      } else if (userRole === "Admin" || userRole === "CMO") {
        url = `${baseUrl}/leads/search?searchKey=${searchKey}`;
      }
    }

    return axios.get(url);
  },

  fetchLeadCounts: async (userRole, selectedTeamId, bodTeamId, leadCounts) => {
    const newLeadCounts = { ...leadCounts };
    const fetchPromises = [];

    const generateUrl = (statusId, teamId, role) => {
      let url = `${baseUrl}/leadsByStatus?leadStatus=${statusId}`;
      if (teamId) {
        url += `&team=${teamId}`;
      }
      if (role) {
        url += `&role=${role}`;
      }
      return url;
    };

    for (const statusId in leadCounts) {
      let url = "";

      if (userRole === "MD" && selectedTeamId) {
        url = generateUrl(statusId, selectedTeamId, userRole);
      } else if (userRole === "Admin" || userRole === "CMO") {
        url = generateUrl(statusId);
      } else if (userRole === "BOD") {
        url = generateUrl(statusId, bodTeamId, userRole);
      }

      fetchPromises.push(
        axios
          .get(url)
          .then((response) => {
            newLeadCounts[statusId] = response.data.leadCount;
          })
          .catch((error) => {
            console.error(`Error fetching data for status ${statusId}:`, error);
          })
      );
    }

    await Promise.all(fetchPromises);
    return newLeadCounts;
  },

  fetchDealsByLeadId: (leadDocId) => {
    const url = `${baseUrl}/getDealsByLeadId?leadDocId=${leadDocId}`;
    return axios.get(url);
  },
  fetchLeadHistoryByDocId: (docId) => {
    const url = `${baseUrl}/getLeadHistoryByDocId?docId=${docId}`;
    return axios.get(url);
  },
  fetchLeadNotesHistoryByDocId: (docId) => {
    const url = `${baseUrl}/getLeadNotesHistoryByDocId?docId=${docId}`;
    return axios.get(url);
  },
  fetchLeadsByTeam: (teamId) => {
    return axios.get(`${baseUrl}/leadsByTeam?team=${teamId}`);
  },

  fetchLeadCountByTeam: (teamId) => {
    return axios.get(`${baseUrl}/leadCountByTeam?team=${teamId}`);
  },
  fetchLeadById: (leadId) => {
    return axios.get(`${baseUrl}/lead?id=${leadId}`);
  },
  individualLeadReassign: (leadData)=>{
    return axios.post(`${baseUrl}/leads/assignToUser`, leadData)
  },
  leadNameAndPhone: (body)=>{
    return axios.post(`${baseUrl}/leadNameAndPhoneNumber`,body)
  },
  getParticularUserLeadStatusList : (obj)=>{
    return axios.post(`${baseUrl}/leads/leadStatusByUser`, obj)
  },
  getLeadStatusList : (obj)=>{
    return axios.post(`${baseUrl}/leads/getAllLeadStatus`, obj)
  },
  getAssignSummaryList: (filters) => {
    const params = new URLSearchParams();
  
    if (filters.next) params.append("next", filters.next);
    if (filters.previous) params.append("previous", filters.previous);
    if (filters.direction) params.append("direction", filters.direction);


  
    return axios.post(`${baseUrl}/leads/assignSummary?${params.toString()}`, {
      teamId: filters.teamId,
      uid: filters.uid,
      stDate: filters.stDate,
      edDate: filters.edDate
    });
  },
  getLeadAssignSummaryList: (body) =>{
    return axios.post(`${baseUrl}/lead/getAssignSummaryVersionTwo`,body)
  },
  getUnassignLead: (filters) => {
    const params = new URLSearchParams();
  
    if (filters.leadSourceId) params.append("leadSourceId", filters.leadSourceId);
    if (filters.team) params.append("team", filters.team);
    if (filters.teamId) params.append("teamId", filters.teamId);
    if (filters.next) params.append("next", filters.next);
    if (filters.previous) params.append("previous", filters.previous);
    if (filters.direction) params.append("direction", filters.direction);
  
    return axios.get(`${baseUrl}/leads/unAssignedLeads?${params.toString()}`);
  },
  // postAssignLeads: (body)=>{
  //   return axios.post(`${baseUrl}/leads/assignVersionTwo`, body)
  // },
  postAssignToLead : (body)=>{
    return axios.post(`${baseUrl}/lead/assignLeadToTeamAndUser`, body)
  },

  postBODBulkAssign: (body)=>{
    return axios.post(`${baseUrl}/leads/bulkAssignLeadForBod`, body)
  },
  // assignSingleLead: (body)=>{
  //   return axios.post(`${baseUrl}/leads/assign-one-lead`, body)
  // },
  getFilteredLeadList: (body) => {
    return axios.post(`${baseUrl}/leads/bulk-reassign-filter`, body)
  },
  getLeadDadhBoardCount : (body) => {
    return axios.post(`${baseUrl}/leads/card-count`, body)
    },
    getLeadData : (body) => {
      return axios.post(`${baseUrl}/leads`, body)
    },
    getLeadDashBoardFilter : (body) => {
      return axios.post(`${baseUrl}/leads/filter`, body)
      },
      getLeadDashBoardFilterSearch : (body) => {
        return axios.post(`${baseUrl}/leads/search`, body)
        },
        leadAssign : (body) =>{
          return axios.post(`${baseUrl}/lead/getUnassignedLead`, body)
        },
        getUnAssignedCount : (body) =>{
          return axios.post(`${baseUrl}/lead/getUnnassignedLeadCount`, body)
        },
        bulkUnAssignLead : (body) =>{
          return axios.post(`${baseUrl}/lead/bulkLeadAssign`, body)
        }
  
  
  

};

export default LeadDbService;
